/* global __application_api_path__, __application_static_path__ */

// GLOBAL
export const APP_API_PATH = __application_api_path__
export const APP_STATIC_PATH = __application_static_path__